import React, { memo } from 'react'
import { string } from 'prop-types'

export const BellAlert = memo(({ color = '#000', height = '100%', width = '100%' }) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 24 23"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
		>
			<g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<g id="1---MBP-CatPg-" transform="translate(-379.000000, -902.000000)" fill={color}>
					<g id="Alert-Card" transform="translate(354.000000, 870.000000)">
						<g id="Icons" transform="translate(22.000000, 0.000000)">
							<g id="ic_alert_sm---2" transform="translate(3.000000, 31.000000)">
								<g
									id="L"
									transform="translate(5.000000, 6.000000) rotate(4.000000) translate(-5.000000, -6.000000) translate(1.000000, 1.000000)"
								>
									<path
										d="M4.88239971,8.4391995 L3.3023998,8.18319951 C3.65279978,6.02319964 5.0599997,4.21359975 7.06559958,3.3415998 L7.70399954,4.80879971 C6.22239963,5.45359967 5.14079969,6.84399959 4.88239971,8.4391995"
										id="Fill-1727"
									></path>
									<path
										d="M1.5999999,9.23759945 L-9.09494648e-14,9.23759945 C-9.09494648e-14,4.9607997 2.87039983,1.16319993 6.98159958,1.79767301e-13 L7.41679956,1.53919991 C3.99199976,2.50799985 1.5999999,5.67359966 1.5999999,9.23759945"
										id="Fill-1730"
									></path>
								</g>
								<g
									id="R"
									transform="translate(19.000000, 6.000000) rotate(-6.000000) translate(-19.000000, -6.000000) translate(15.000000, 1.000000)"
								>
									<path
										d="M2.82159983,8.4399995 C2.56319985,6.84479959 1.48159991,5.45439967 1.36424197e-13,4.80959971 L0.638399962,3.3423998 C2.64399984,4.21439975 4.05119976,6.02399964 4.40159974,8.18399951 L2.82159983,8.4399995 Z"
										id="Fill-1728"
									></path>
									<path
										d="M7.75399954,9.23839945 L6.15399963,9.23839945 C6.15399963,5.67519966 3.76119978,2.50879985 0.33559998,1.53919991 L0.772399954,2.13162808e-15 C4.88279971,1.16399993 7.75399954,4.9623997 7.75399954,9.23839945"
										id="Fill-1729"
									></path>
								</g>
								<g id="Fill-1725-+-Fill-1726" transform="translate(4.000000, 7.000000)">
									<path
										d="M4.9992302,14.4000006 C5.62293022,15.4710006 6.77133027,16.2000006 8.09973032,16.2000006 C9.42903037,16.2000006 10.5765304,15.4710006 11.2011304,14.4000006 L4.9992302,14.4000006 Z"
										id="Fill-1725"
									></path>
									<path
										d="M2.73123011,11.7000005 L13.4691305,11.7000005 C12.3702305,10.7982004 11.6997305,9.43740038 11.6997305,7.95420032 L11.6997305,5.40000021 C11.6997305,3.41460014 10.0851304,1.80000007 8.09973032,1.80000007 C6.11523024,1.80000007 4.49973018,3.41460014 4.49973018,5.40000021 L4.49973018,7.95420032 C4.49973018,9.43740038 3.82923015,10.7982004 2.73123011,11.7000005 L2.73123011,11.7000005 Z M16.1997306,13.5000005 L-0.000270000011,13.5000005 L-0.000270000011,11.0511004 L0.615330024,10.8468004 C1.86183007,10.4301004 2.69973011,9.26820037 2.69973011,7.95420032 L2.69973011,5.40000021 C2.69973011,2.4219001 5.1225302,0 8.09973032,0 C11.0778304,0 13.4997305,2.4219001 13.4997305,5.40000021 L13.4997305,7.95420032 C13.4997305,9.26820037 14.3385306,10.4301004 15.5850306,10.8468004 L16.1997306,11.0511004 L16.1997306,13.5000005 Z"
										id="Fill-1726"
									></path>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>
	)
})

BellAlert.propTypes = {
	color: string,
	height: string,
	width: string,
}
